import { createAsyncThunk } from '@reduxjs/toolkit';

import { SHOPIFY_CHANNEL_TYPE } from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const completePendingSalesChannel = createAsyncThunk(
  'salesChannels/completePendingSalesChannel',
  async (_, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.saveSalesChannel({
        type: SHOPIFY_CHANNEL_TYPE,
        setupStatus: 'complete',
      });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Complete pending sales channel failed'),
        { error },
        ['ConnectShopifyChCompletePendingFailed', {}],
      );
      throw error;
    }
  },
);
